/* ################################################################### */
/* FUNCTION (SELECTS) ################################################ */
/* ################################################################### */
function selects(speed, ease, customDropdown)
{
	jQuery('.select').each(function(index, element)
	{
		var select          = jQuery(element);
			selectContainer = select.parent();

		// SPAN
		selectContainer.append('<span></span>');    // Create SPAN
		var selectSpan = selectContainer.find('span');

		// init SPAN
		if(jQuery('option:selected', select).length == 0)
			selectSpan.html(jQuery('option', select).eq(0).html());
		else
			selectSpan.html(jQuery('option:selected', select).html());

		if(customDropdown)
		{
			// UL
			selectContainer.append('<ul></ul>');        // Create UL
			var selectUl   = selectContainer.find('ul');

			// init UL
			jQuery('option', select).each(function(index, element)
			{
				selectUl.append('<li>' + jQuery(element).html() + '</li>');
			});
		}
		else
		{
			select.addClass('noCustomList');
		}

		// Mobile
		select.change(function()
		{
			selectSpan.html(jQuery('option:selected', select).html());
		});
	});

	if(customDropdown)
	{
		// Open / Close dropdown menu
		jQuery('span', '.field_select').on('click', function()
		{
			jQuery(this).toggleClass('active');
			jQuery(this).next('ul').fadeToggle(speed, ease);
		});

		// LI
		jQuery('li', '.field_select').on('click', function()
		{
			var optIndex = jQuery(this).index();
				optVal   = jQuery(this).html();
				select   = jQuery(this).parents('.field_select').find('select');
				span     = jQuery(this).parents('.field_select').find('span');
				ul       = jQuery(this).parents('ul');

			// Update SELECT
			jQuery('option', select).eq(optIndex).prop('selected', true);

			// Update SPAN
			span
				.html(jQuery('option:selected', select).html())
				.removeClass('active');

			// Close UL
			ul.fadeOut(speed, ease);
		});

		// Close on click outside
		jQuery('html').click(function(e)
		{
			if(jQuery('.field_select span.active + ul').is(':visible') && jQuery('.field_select:hover').length == 0)
			{
				jQuery('.field_select span.active + ul').fadeOut(speed, ease);
				jQuery('.field_select span.active').removeClass('active');
			}
		});
	}
}

